import React from "react";
import { useTranslation } from "@ca-dmv-radv/translation";
import PhoneInputWithCountrySelect from "react-phone-number-input";

export default function IntlPhoneNumber({ phoneNumber, setPhoneNumber }) {
  const { t } = useTranslation();

  return (
    <div>
      <h6 className="mb-5 text--blue-dark-2 text--xxxsm">
        {t(
          "screens-Dashboard-Modal-TakePhoto-phoneLabel",
          "Mobile Phone Number"
        )}
      </h6>
      <PhoneInputWithCountrySelect
        value={phoneNumber}
        onChange={(value) => setPhoneNumber(value || "")}
        defaultCountry="US"
        limitMaxLength
        focusInputOnCountrySelection
        className="max-width--300"
      />
      <p className="mt-5 text--xsm">
        {t(
          "screens-Dashboard-Modal-TakePhoto-phoneHint",
          "Numbers only, no special characters"
        )}
      </p>
    </div>
  );
}
